import { EnvConfig } from "../../types";

export const adminConfigProd: EnvConfig = {
  ENV: "prod",
  MODULE_NAME: "admin",
  MODULE_ENV: "prod",
  LD_CLIENT_SIDE_ID: "63583be10d275b11a1f32f7c",
  BRIDGE_SCOPES: [
    "bridge.signin",
    "openid",
    "cxm-private.cxm-ui-bff.insights.read",
    "cxm-private.cxm-ui-bff.insights.read"
  ],
  BRIDGE_RUNTIME: "PRODUCTION",
  BRIDGE_CLIENT_ID: "0oaj7hcoekerOmcDu357",
  BASE_URL: "https://cxm-ui-bff-api.pipelines.app.coxautoinc.com/",
  REAL_TIME_URL: "https://cxm-realtime-api.pipelines.app.coxautoinc.com/",
  MANIFEST_URL:
    "https://pipelines.app.coxautoinc.com/module-federation.manifest.json"
};
